import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-stock-places-to',
  templateUrl: './stock-places-to.component.html',
  styleUrls: ['./stock-places-to.component.css']
})
export class StockPlacesToComponent implements OnInit {
    stockPlaceIdFrom;

    public setting?: Setting;

    public itemsListStockPlacesTo: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockPlaceIdFrom = this.stateService.getStateParams()['stockplace_id_from'];
    }

    private async loadSetting() {
        if (!!this.stockPlaceIdFrom) {
            this.setting = (await this.datatask.Post(2172, { stockplace_id_from: this.stockPlaceIdFrom }))[0];
        }
    }

    private async loadStockPlacesTo(): Promise<void> {
        if (this.setting?.stockplace_id_from) {
            this.itemsListStockPlacesTo = await this.datatask.Post(2173, { stockplace_id_from: this.setting.stockplace_id_from });
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadStockPlacesTo();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_id_from: number;
    stockplace_name_from: string;
    searchtext: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockPlacesTo', {
//        templateUrl: 'views/components/views/stockPlacesTo/stockPlacesTo.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'stockPlacesToService', 'rememberService', function ($stateParams, stateService, utilityService, stockPlacesToService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockPlaceIdFrom = $stateParams.stockplace_id_from;

//            let variableNames = {
//                searchtext: ''
//            };

//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => reset('searchtext') }
//                ],
//                setting: {},
//                itemsListStockPlacesTo: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await stockPlacesToService.getSetting({ stockplace_id_from: stockPlaceIdFrom }))[0];

//                loadStockPlacesTo();
//            }

//            async function loadStockPlacesTo() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from) !== true) return;

//                vm.model.itemsListStockPlacesTo = (await stockPlacesToService.listStockPlacesTo({ stockplace_id_from: vm.model.setting.stockplace_id_from }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function reset(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext > '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') rememberFunc('searchtext');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
